import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface UploadConfigDialogResult{
  upload: boolean,
  file: File
}

@Component({
  selector: 'app-upload-config-dialog',
  templateUrl: './upload-config.component.html',
  styleUrls: ['./upload-config.component.scss']
})
export class UploadConfigComponent {

  private selectedFiles: FileList;
  private currentFile: File;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<UploadConfigComponent>) {}

  close() { this.dialogRef.close(this.generateDialogResult(true)); }
  cancel() { this.dialogRef.close(this.generateDialogResult(false)); }

  selectFile(event: any): void {
    this.selectedFiles = event.target.files;
    this.currentFile = this.selectedFiles.item(0);
  }

  private generateDialogResult(upload: boolean): UploadConfigDialogResult{
    return {
      upload: upload,
      file: this.currentFile
    }
  }
}